import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useCurrentSection } from '@/hooks/useCurrentSection';

interface PageHeaderProps {
  title: string;
  backPath: string;
  section?: 'tasks' | 'calendar' | 'persons' | 'contacts' | 'dashboard' | 'profile';
}

export function PageHeader({ title, backPath, section }: PageHeaderProps) {
  const navigate = useNavigate();
  const { secondaryVariant } = useCurrentSection();

  return null;
}